import React, { FC, useState, useEffect } from 'react'
import { Button, Table, Input, Row, Col, Form, Upload, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { ISupplierSupplyDetails } from '../../../supplierTypes'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { useSupplierDetailsMode } from '../supplierDetailsModel'
import { useSupplyDetailsMode } from './supplyDetailsModel'
import { importPropsConfig } from '@/utils/importFile'
import { SupplyDetailsModal } from './SupplyDetailsModal'


export const SupplyDetails: FC<RouterParamType> = ({ id, mode }) => {
    const { editFormVal } = useSupplierDetailsMode()
    const { setLoadingInfo, user } = useGlobalModel()
    const { dataSource, selectedRowKeys, setSelectedRowKeys, pgCfg, loading, loadData, supplierCodeRef, templateDownload, handleDelete, handleView, handleEdit } = useSupplyDetailsMode()

    useEffect(() => {
        if (editFormVal.code) {
            supplierCodeRef.current = editFormVal.code
            loadData()
        }
    }, [editFormVal.code])

    // 表格列定义
    const columns: ColumnsType<ISupplierSupplyDetails> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => (pgCfg.current! - 1) * pgCfg.pageSize! + i + 1,
        },
        {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            width: 140,
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            width: 120,
            dataIndex: 'unit',
        },
        {
            title: '型号',
            width: 100,
            dataIndex: 'model',
        },
        {
            title: '品系',
            width: 120,
            dataIndex: 'productLine',
        },
        {
            title: '品种',
            width: 120,
            dataIndex: 'variety',
        },
        {
            title: '生产厂家',
            width: 120,
            dataIndex: 'manufacturer',
        },
        {
            title: '品牌',
            width: 120,
            dataIndex: 'brand',
        },
        {
            title: '配件返利类别',
            width: 120,
            dataIndex: 'rebateCategory',
        },
        {
            title: '供货价格',
            width: 120,
            dataIndex: 'supplyPrice',
        },
        {
            title: '操作',
            width: 240,
            dataIndex: 'supplyQuantity',
            fixed: 'right',
            render: (t: Event, r: ISupplierSupplyDetails, i: number) => (
                <>
                    <span className="mr-10" onClick={() => {
                        handleView(r)
                    }}>
                        查看
                    </span>
                    <span className="mr-10" onClick={() => {
                        handleEdit(r)
                    }}>
                        编辑
                    </span>
                     <span className="mr-10 color-red" onClick={() => {
                        handleDelete(r)
                     }}>
                        删除
                    </span>
                </>
            ),
        },
    ]

    const upLoadCallback = (value: { list: any[]; msg: string }) => {
        message.info(value?.msg)
        setLoadingInfo({ loadingVisible: false, txt: '' })
        loadData()
    }

    const action = (
        <>
            <Button className="mr-5" type="link" shape="round" onClick={templateDownload}>
                模版下载
            </Button>
            <Upload
                showUploadList={false}
                className="mr-10 ml-10"
                {...importPropsConfig(`/sum/supply/import`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中' }), true, {
                    code: supplierCodeRef.current,
                    name: editFormVal.name,
                    createUser: user?.userName,
                })}
            >
                <Button className="mr-5" type="link" shape="round">
                    导入明细
                </Button>
            </Upload>
        </>
    )

    return (
        <YhBox style={{ padding: '20px' }} action={action}>
            <Table
                rowKey={(record) => record.id}
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomCenter'],
                    showTotal: (total) => `共${total}条`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                }}
                scroll={{ x: 'max-content', y: '400px' }}
            />
            <SupplyDetailsModal />
        </YhBox>
    )
}
